const employment = {
    employmentPhrase1: '¿Te gustaría formar parte en nuestro proyecto de democratizar arte y promocionar cultura?',
    employmentPhrase2: '¡Mandanos un mensaje a través de nuestro formulario de contacto!',
 };
  
 module.exports = employment; 